import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex } from "@chakra-ui/react";
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { updateDsrAction } from '../actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';
import { RiDeleteBack2Fill } from 'react-icons/ri';


function DeleteCategoryModal({
  dsrId,
  mapCategoryId,
  showModal,
  handleCloseModal,
  updateDsrActionOutcome,
  updateDsrAction
}) {

  const accentColor = 'brandPink.500';

  // UX Management
  const [showLoader, setShowLoader] = useState(false)


  useEffect(() => {
    if (updateDsrActionOutcome) {
      setShowLoader(false)
      handleCloseModal()
    }

  }, [updateDsrActionOutcome, handleCloseModal]);



  // Functions
  function handleClickDeleteCategory() {
    const updateActionMetadata = {
      dsrId,
      mapCategoryId,
      event: "delete-category"
    }

    updateDsrAction(updateActionMetadata)
  }

  function renderDeleteActionCategoryModalContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <>
          <Flex justify='center' mt='1em' mb='1.6em' w='100%' px='1em'>
            <Box w="100%" px='1em' fontSize='0.875em' color='brandDark.500'>
              Are you sure about deleting this entire category & tasks inside?
            </Box>
          </Flex>

          <Flex w='100%'>
            <Flex my='0.625em' justify='flex-end' w='100%' px='1em'>
              <LaunchdeckButton label='Yes, delete' fontSize='0.8em' py='0.4em' bg={accentColor} color='gray.50' onClick={() => handleClickDeleteCategory()} />
            </Flex>
          </Flex>
        </>
      )
    }
  }


  // Render
  if (!showModal) {
    return null;
  }

  if (showModal) {
    return (
      <LaunchdeckModal
        title={<Flex gap='1em' justify='flex-start' align='center'>
          <Box as={RiDeleteBack2Fill} color='white' boxSize="1em" />
          <Box color='white'>Delete category</Box>
        </Flex>}
        handleCloseModal={handleCloseModal}
        showModal={true}
        maxW='35em'
      >
        <>


          {renderDeleteActionCategoryModalContent()}
        </>
      </LaunchdeckModal>

    )
  }
}

function mapStateToProps(state) {
  return {
    updateDsrActionOutcome: state.updateDsrActionOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsrAction
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteCategoryModal));